export default __webpack_public_path__ + "static/media/sunset_at_san_pedro_beach.2e086b69.jpg";